<template>
  <a-button
    v-if="isShowed"
    class="BackButton inline-flex items-center justify-center w-12 p-0"
    @click="navigateBack"
  >
    <a-icon type="left" />
  </a-button>
</template>


<script lang="ts">
import useBreadcrumb from '@/composables/useBreadcrumb'
import { defineComponent, computed } from '@vue/composition-api'
import { useEnv } from '../composables/useEnvironment'

export default defineComponent({
  name: 'Breadcrumb',

  setup(_, { root }) {
    const { withEnv } = useEnv()
    const { routes } = useBreadcrumb()
    const isShowed = computed(() => {
      return routes.value.length > 1
    })

    const navigateBack = () => {
      root.$router.push(withEnv(routes.value[routes.value.length - 2].path))
    }

    return {
      isShowed,
      navigateBack
    }
  }
})
</script>

<style lang="css">
.BackButton.ant-btn {
  min-width: 0;
  height: 2.2rem;
}
</style>